import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import Card from "./Card";
import { getColorFromPercentage } from "../../utils/colors";
import PercentageIndicator from "./PercentageIndicator";

export const AnnualComparativeCard = ({ data, percentage }) => {
  const color = getColorFromPercentage(percentage);

  return (
    <Card
      header={{
        hardTitle: "Comparativo anual",
      }}
      style={{
        minHeight: "auto",
        padding: "12px 16px",
      }}
    >
      <Box sx={{ position: "relative", width: "100%" }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mb: 1.5,
            mt: -0.5,
          }}
        >
          Desempenho em Positivação Total
        </Typography>

        <Box
          sx={{
            position: "absolute",
            top: -32,
            right: 0,
          }}
        >
          <PercentageIndicator value={percentage} color={color} />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            pl: 0,
            pr: 0,
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              variant="h5"
              fontWeight={500}
              sx={{
                color,
                lineHeight: 1,
              }}
            >
              {data.comparativeCurrentPoints}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontSize: "0.875rem",
              }}
            >
              período atual
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              marginLeft: "auto",
            }}
          >
            <Typography
              variant="h5"
              fontWeight={500}
              color="text.secondary"
              sx={{
                lineHeight: 1,
              }}
            >
              {data.comparativePreviousPoints}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontSize: "0.875rem",
              }}
            >
              mesmo período do ano anterior
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

AnnualComparativeCard.propTypes = {
  data: PropTypes.shape({
    comparativeCurrentPoints: PropTypes.string,
    comparativePercentage: PropTypes.string,
    comparativePreviousPoints: PropTypes.string,
  }).isRequired,
  percentage: PropTypes.number.isRequired,
};
